export default class Marker {
    static createMarkerElement(id: string, main: boolean, latitude: number, locked: boolean = false): HTMLElement {
        const markerElement = document.createElement('div');
        const fill = locked ? "#aaaaaa" : main ? "#5cd5eb" : "#ff6b6b";
        markerElement.innerHTML = `
            <svg width="26" height="38" viewBox="0 0 26 38" style="margin-left: -13px; margin-top: -37px;">
                <ellipse
                    cx="13"
                    cy="35"
                    rx="6"
                    ry="2"
                    fill="rgba(0,0,0,0.2)"
                />
                <path
                    d="M13 1C6.4 1 1 6.4 1 13c0 7.5 12 24 12 24s12-16.5 12-24c0-6.6-5.4-12-12-12z"
                    fill="${fill}"
                    stroke="black"
                    stroke-width="0.75"
                />
                <circle
                    cx="13"
                    cy="13"
                    r="6"
                    fill="#FFFFFF"
                />
            </svg>
        `;
        const normalizedZIndex = Math.round(10 + ((90 - latitude) / 180) * 70);
        markerElement.style.zIndex = normalizedZIndex.toString();
        if (locked) {
            markerElement.style.cursor = "default";
        }
        return markerElement;
    }
}
